import { render, staticRenderFns } from "./detailChargeCode.vue?vue&type=template&id=15c3e833"
import script from "./detailChargeCode.vue?vue&type=script&lang=js"
export * from "./detailChargeCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports